import type { Feature, Polygon } from 'geojson'

const EARTH_RADIUS_KM = 6371

export function circlePolygon(
  lat: number,
  lng: number,
  radiusKm: number,
  steps = 64,
): Feature<Polygon> {
  const coords: Array<[number, number]> = []
  const angularDistance = radiusKm / EARTH_RADIUS_KM
  const latRad = (lat * Math.PI) / 180
  const lngRad = (lng * Math.PI) / 180

  for (let i = 0; i <= steps; i++) {
    const bearing = (i * 2 * Math.PI) / steps
    const sinLat2 =
      Math.sin(latRad) * Math.cos(angularDistance) +
      Math.cos(latRad) * Math.sin(angularDistance) * Math.cos(bearing)
    const lat2 = Math.asin(sinLat2)
    const lng2 =
      lngRad +
      Math.atan2(
        Math.sin(bearing) * Math.sin(angularDistance) * Math.cos(latRad),
        Math.cos(angularDistance) - Math.sin(latRad) * sinLat2,
      )
    coords.push([(lng2 * 180) / Math.PI, (lat2 * 180) / Math.PI])
  }

  return {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [coords],
    },
  }
}

// circleBounds returns a [minLng, minLat, maxLng, maxLat] envelope suitable for
// MapLibre's fitBounds.
export function circleBounds(
  lat: number,
  lng: number,
  radiusKm: number,
): [[number, number], [number, number]] {
  const dLat = radiusKm / 111
  const cosLat = Math.max(Math.cos((lat * Math.PI) / 180), 1e-6)
  const dLng = radiusKm / (111 * cosLat)
  return [
    [lng - dLng, lat - dLat],
    [lng + dLng, lat + dLat],
  ]
}
